export const locationTypeSelection = {
    event: "location_type_selection",
    eventCategory: "location_type_page"
};

export const locationAccess = {
    event: "location_access",
    eventCategory: "location_type_page"
};

export const locationMethodSelection = {
    event: "location_method_selection",
    eventCategory: "location_type_page"
};
